import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Overwrite } from 'utility-types';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationTopicsApi } from '@/Domain/api/Conversation/ConversationTopics.api';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicCreate = () => {
  const { t } = useTranslation('capabilities');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.conversationTopics.create}-create`],
    mutationFn: (topic: Overwrite<TopicDto, { id?: number }>) =>
      ConversationTopicsApi.create(topic),
    onSuccess: (data) => {
      queryClient.setQueryData(
        [`${Endpoint.conversationTopics.list}-list`],
        (prevData: TopicDto[]) => [...prevData, data],
      );
    },
    onError: (error: AxiosError) => {
      toast.error(
        get(error, 'response.data.errors.root[0].message') || t('toast.create_topic.error'),
      );
    },
  });

  const handleCreateTopic = () => mutation.mutate({ topic: '', topic_description: '' });

  return { handleCreateTopic, isPending: mutation.isPending };
};
